import { Component, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {
  CustomModalConfig,
  NgbCustomModalComponent,
} from 'components/modal-windows/ngb-custom-modal/ngb-custom-modal.component';
import { Observable, Subject } from 'rxjs';
import { DEFAULT_MODAL_OPTIONS } from 'constants/constants';

interface UndeletableMeta {
  groupName: string;
  fieldNames: string[];
}

@Component({
  selector: 'cm-template-group-undeletable-modal',
  templateUrl: './template-group-undeletable-modal.component.html',
  styleUrls: ['./template-group-undeletable-modal.component.scss'],
})
export class TemplateGroupUndeletableModalComponent {
  @ViewChild('template') template;
  undeletableMeta: UndeletableMeta = {
    groupName: '',
    fieldNames: [],
  };

  private onClose = new Subject<null>();

  modalRef;

  constructor(private modalService: NgbModal) {}

  close() {
    this.onClose.next(null);
  }

  open(undeletableMeta: UndeletableMeta): Observable<null> {
    this.undeletableMeta = undeletableMeta;
    return Observable.create((observer) => {
      this.openModal();
      const onCloseSub = this.onClose.subscribe(observer);
      return () => {
        this.closeModal();
        onCloseSub.unsubscribe();
      };
    });
  }

  private openModal() {
    const modalConfig: CustomModalConfig = {
      title: 'Delete group',
      isCloseCrossVisible: false,
      hasCustomFooter: true,
      type: 'organization',
      hideHeader: false,
    };
    this.modalRef = this.modalService.open(NgbCustomModalComponent, {
      ...DEFAULT_MODAL_OPTIONS,
      windowClass: 'sm',
    });
    this.modalRef.componentInstance.template = this.template;
    this.modalRef.componentInstance.config = modalConfig;
  }

  private closeModal() {
    this.modalRef.close();
  }
}
